import { render, staticRenderFns } from "./LatestNews.vue?vue&type=template&id=1282d302&"
import script from "./LatestNews.vue?vue&type=script&lang=ts&"
export * from "./LatestNews.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports